var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14464"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "clipboard (2)",
    d: "M12.667.829V2.05a2.052 2.052 0 0 1-2.051 2.051H6.103A2.052 2.052 0 0 1 4.05 2.05V.829A2.258 2.258 0 0 0 2 3.077v10.667A2.255 2.255 0 0 0 4.256 16h8.205a2.255 2.255 0 0 0 2.256-2.256V3.077a2.258 2.258 0 0 0-2.05-2.248zM9.179 12.718H5.897a.616.616 0 1 1 0-1.231h3.282a.616.616 0 0 1 0 1.231zm1.641-2.462H5.897a.616.616 0 1 1 0-1.231h4.923a.616.616 0 0 1 0 1.231zm0-2.462H5.897a.616.616 0 1 1 0-1.231h4.923a.616.616 0 0 1 0 1.231zM5.282 2.05V.821A.821.821 0 0 1 6.103 0h4.513a.821.821 0 0 1 .821.821V2.05a.821.821 0 0 1-.821.821H6.103a.821.821 0 0 1-.821-.821z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDocument);
export default __webpack_public_path__ + "static/media/viewDocument.b4d12d861c9d2b6a47c4816a1398e9a8.svg";
export { ForwardRef as ReactComponent };